import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Roles } from '../../utilities/enums/Roles';

// represents the shape of the slice in state
interface AuthRolesState {
  isAuthorized: boolean;
  roles: string[];
}

const initialState: AuthRolesState = {
  isAuthorized: false,
  roles: [],
};

const roles = [
  Roles.Admin,
  Roles.Agency,
  Roles.AgRev,
  Roles.AgSup,
  Roles.GovRev,
  Roles.GovSup,
  Roles.SosOffice,
];

const authRolesSlice = createSlice({
  name: 'stateAuthRoles',
  initialState,
  reducers: {
    addRole(state, action: PayloadAction<string>) {
      // its okay to set items directly despite redux being immutable because immer doing its thing under the hood
      state.roles.push(action.payload);
    },
    // This reducer is used on the private page component that just checks against any role
    validateUserRoles(state) {
      // get items from session storage
      let bearer = sessionStorage.getItem('token');
      let userRoles = sessionStorage.getItem('roles');
      // if use has roles check if the role is of a valid type
      if (roles && roles?.length > 0) {
        if (userRoles && bearer) {
          let parsedUserRoles: any[] = JSON.parse(userRoles);
          state.roles = parsedUserRoles;
          parsedUserRoles.forEach((element) => {
            let found = roles.indexOf(element) > -1;
            if (found) {
              state.isAuthorized = true;
              return;
            }
          });
        }
      }
    },
    setRoles(state, action: PayloadAction<any>) {
      state.roles = action.payload;
    },
    clearRoles(state) {
      state.roles = [];
    },
    setAuthorized(state, action: PayloadAction<boolean>) {
      state.isAuthorized = action.payload;
    },
  },
});

export const { addRole, setRoles, clearRoles, setAuthorized, validateUserRoles } =
  authRolesSlice.actions;
export default authRolesSlice.reducer;
